import { render, staticRenderFns } from "./mbSoftwaremaintenance.vue?vue&type=template&id=738ceb74&scoped=true&"
import script from "./mbSoftwaremaintenance.vue?vue&type=script&lang=js&"
export * from "./mbSoftwaremaintenance.vue?vue&type=script&lang=js&"
import style0 from "./mbSoftwaremaintenance.vue?vue&type=style&index=0&id=738ceb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ceb74",
  null
  
)

export default component.exports